import { render, staticRenderFns } from "./subMatchLogInfo.vue?vue&type=template&id=18949915&scoped=true&lang=pug&"
import script from "./subMatchLogInfo.vue?vue&type=script&lang=js&"
export * from "./subMatchLogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18949915",
  null
  
)

export default component.exports